import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ManageScreeningQuestions } from '../components/ScreeningQuestions';
import { ArrowLeft } from 'lucide-react';
import api from '../api';

export default function ManageJobScreening() {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJob = async () => {
      try {
        const res = await api.get(`/api/jobs/${jobId}`);
        setJob(res.data);
      } catch (err) {
        console.error('Failed to fetch job:', err);
      } finally {
        setLoading(false);
      }
    };

    if (jobId) {
      fetchJob();
    }
  }, [jobId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <button
          onClick={() => navigate('/dashboard')}
          className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-6"
        >
          <ArrowLeft size={20} />
          Back to Dashboard
        </button>

        <div className="mb-6">
          <h1 className="text-3xl font-bold">{job?.title}</h1>
          <p className="text-gray-600">Manage screening questions for this job</p>
        </div>

        <ManageScreeningQuestions jobId={jobId} />

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
          <h3 className="font-semibold text-blue-900 mb-2">💡 Tips for Effective Screening Questions</h3>
          <ul className="text-sm text-blue-800 space-y-1 list-disc list-inside">
            <li>Keep questions clear and specific to the role</li>
            <li>Use multiple choice or yes/no questions for faster screening</li>
            <li>Ask about required skills, experience, or availability</li>
            <li>Limit to 3-5 questions to avoid overwhelming candidates</li>
            <li>Questions will be automatically scored to help you filter candidates</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
